const env = {
  API: import.meta.env.VITE_API,
  AUTH_DOMAIN: import.meta.env.VITE_AUTH_DOMAIN,
  CLIENT_ID: import.meta.env.VITE_CLIENT_ID,
  AUDIENCE: import.meta.env.VITE_AUDIENCE,
  GOOGLE_MAPS_API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  ZOOM_SDKKEY: import.meta.env.VITE_ZOOM_SDKKEY,
  DEV_PK_STRIPE_BR: import.meta.env.VITE_DEV_PK_STRIPE_BR,
  DEV_PK_STRIPE_US: import.meta.env.VITE_DEV_PK_STRIPE_US,
  PK_STRIPE_PROD_BR: import.meta.env.VITE_PK_STRIPE_PROD_BR,
  PK_STRIPE_PROD_US: import.meta.env.VITE_PK_STRIPE_PROD_US,
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT,
  // The dev deploy is also a production build; its workflow passes
  // VITE_ROLLBAR_ENV=development so its errors stay out of production.
  ROLLBAR_ENV:
    import.meta.env.VITE_ROLLBAR_ENV ||
    (import.meta.env.MODE === 'production' ? 'production' : 'development'),
  ROLLBAR_TOKEN: import.meta.env.VITE_ROLLBAR_TOKEN,
  MODE: import.meta.env.MODE,
};

export const isDev = env.MODE === 'development';
export const isProd = env.MODE === 'production';

export default env;
